import React from 'react';
import { motion, useIsPresent } from 'framer-motion';
import SpinnerRing from './components/SpinnerRing';

const transition = (OgComponent) => {
    return (props) => {
        const wait = !!props?.waitForReady;
        const isPresent = useIsPresent();
        const [enterReady, setEnterReady] = React.useState(!wait);
        React.useEffect(() => {
            if (!wait) return;
            const handler = () => setEnterReady(true);
            window.addEventListener('pageEnterReady', handler);
            return () => window.removeEventListener('pageEnterReady', handler);
        }, [wait]);

        const showSpinner = (!enterReady) || !isPresent;
        const transitioning = (!enterReady) || !isPresent;

        React.useEffect(() => {
            try { window.dispatchEvent(new CustomEvent('transitionSpinnerVisible', { detail: { visible: !!showSpinner } })); } catch(_) {}
        }, [showSpinner]);

        React.useEffect(() => {
            try {
                document.body.classList.toggle('is-transitioning', !!transitioning);
            } catch(_) {}
            return () => {
                try { document.body.classList.remove('is-transitioning'); } catch(_) {}
            };
        }, [transitioning]);
        return (
        <>
                <OgComponent {...props} />
            <motion.div
                className="slide-in"
                initial={{ scaleY: 0 }}
                animate={{ scaleY: 0 }}
                exit={{ scaleY: 1 }}
                    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            />

                <motion.div
                    className="slide-out"
                    initial={{ scaleY: 1 }}
                    animate={{ scaleY: enterReady ? 0 : 1 }}
                    exit={{ scaleY: 0 }}
                    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                />
            {/* Spinner is rendered globally in App; we only signal visibility here */}
        </>
    );
    };
  };

  export default transition;